import { DAYS_OF_TRIAL } from "@/helpers/variables/backendConstants";

export const common = {
  select: "Seleccionar",
  option: "Opción",
  updates: "Actualizaciones",
  search: "Buscar",
  collaborators: "Colaboradores",
  access: "Acceder",
  for: "por",
  hour: "Hora",
  insertLink: "Insertar enlace",
  understood: "Entendido",
  availableFromSecurity: "Disponible para planes a partir de Security",
  pickADate: "Elige una fecha",
  and: "y",
  pending: "Pendiente",
  next: "Siguiente",
  currentPlan: "Plan actual",
  currentPlans: "Planes actuales",
  free: "Gratuito",
  freeTrialPeriod: `Gratuito (${DAYS_OF_TRIAL} días)`,
  includes: "Incluye:",
  licenseNumber: "Número de licencias",
  recommended: "Recomendado",
  user: "Usuario",
  installment: "Cuota",
  installments: "Cuotas",
  annualPlan: "Plan anual",
  triennialPlan: "Plan trienal",
  trialPlan: "Plan de prueba",
  flexPlan: "Plan mensual",
  freePlan: "Plan gratuito",
  total: "Total",
  licenses: "licencias",
  license: "Licencia",
  to: "para",
  notRegistered: "No registrado",
  payment: "Pago",
  from: "De",
  until: "Hasta",
  since: "Desde",
  second: "segundo",
  seconds: "segundos",
  help: "Ayuda",
  requiredField: "Indica un campo obligatorio",
  start: "Comenzar",
  createUser: "Crear usuario",
  userInfos: "Información del usuario",
  emailSignatureInfomations: "Información para firma de correo electrónico",
  emailSignature: "Firma de correo electrónico",
  accessControl: "Control de acceso",
  selectUser: "Seleccionar usuario",
  name: "Nombre",
  lastName: "Apellido",
  primaryEmail: "Correo electrónico principal",
  secondaryEmail: "Correo electrónico secundario",
  domain: "Dominio",
  supportedFormats: "Formatos compatibles",
  organizationUnit: "Unidad organizacional",
  image: "Imagen",
  back: "Volver",
  advance: "Avanzar",
  prepare: "Preparar",
  group: "Grupo",
  save: "Guardar",
  setting: "Configuración",
  representation: "Representación",
  addUserToGroups: "Agregar usuario a grupos",
  workspaceGroups: "Grupos del Workspace",
  workspaceGroupsDescription:
    "Agrega al usuario a grupos para que pueda enviar y recibir correos con el email del grupo.",
  confirmDeletion: "Confirmar eliminación",
  confirmGroupDeletion: "¿Realmente deseas eliminar al usuario del grupo?",
  addGroupDescription: "Selecciona el grupo al que deseas añadir al usuario",
  saveAsSecondaryEmail: "Guardar como correo secundario del usuario",
  sendEmailAs: "Enviar correo como",
  groupAliasAlreadyInUseforUser:
    "Este grupo ya es un correo secundario de este usuario.",
  requiredEmailService:
    "¡Válido solo para usuarios con servicio de correo electrónico activo!",
  inactiveUserInWorkspaceAlert:
    "¡El servicio de correo electrónico de este usuario no está activo! Verifica la licencia de Workspace.",
  inactiveEmailService:
    "El servicio de correo electrónico de este usuario no está activo",
  multipleInactiveEmailService:
    "Los usuarios con el servicio de correo desactivado no tienen 'Calendario' para añadir otros calendarios.",
  configAlternativeEmails: "Configurar correos alternativos",
  emailsAliases: "alias de correo",
  configAlternativeEmailsDescription:
    "Agrega correos electrónicos alternativos (alias) para que el usuario reciba mensajes desde otras direcciones.",
  receiveEmailsLike: "Recibir correos como",
  addAlternativeEmail: "Agregar correo alternativo",
  confirmDeletionDescription: "¿Realmente deseas eliminar?",
  addAlternativeEmailDescription:
    "Introduce la dirección de correo alternativa desde la cual el usuario podrá recibir mensajes.",
  alternativeEmail: "Correo alternativo",
  configSecondaryEmail: "Configurar correo secundario",
  configSecondaryEmailDescription:
    "Agrega direcciones de correo para que el usuario pueda enviar mensajes desde otras cuentas usando su correo principal.",
  defaultEmail: "Correo predeterminado",
  confirmAction: "¿Realmente deseas confirmar esta acción?",
  confirmChange: "Confirmar cambio",
  confirmChanges: "Confirmar cambios",
  confirmModify: "Confirmar modificación",
  enterNameFor: "Introduce el nombre para",
  descriptionConfirmModification: "¿Realmente deseas modificar?",
  addEmailAddress: "Agregar dirección de correo electrónico",
  secondaryEmailAddressDescription:
    "Agrega direcciones de correo electrónico para que los usuarios puedan usar su correo predeterminado para enviar mensajes desde otras direcciones.",
  applySecondaryEmail: "Aplicar correo secundario",
  optional: "Opcional",
  addSecondaryEmailDescription:
    "Introduce la dirección de correo que los usuarios podrán usar.",
  watchTheVideo: "Mira el video",
  customizedInformation: "Información personalizada",
  subscriptionApp: "Aplicación de firma",
  subscriptionAppTooltipText:
    "Las firmas de correo se agregarán automáticamente al final de los mensajes de Gmail, como un pie de página.",
  searchModel: "Buscar modelo",
  noCustomModelFound: "No se encontró ningún modelo personalizado",
  noDefaultModelFound: "No se encontró ningún modelo predeterminado",
  noModelsSelected: "Ningún modelo seleccionado",
  selectAModel: "Selecciona un modelo para visualizar",
  currentSubscriptionTo: "Suscripción actual de",
  subject: "Asunto",
  checkTheNewSignature: "¡Revisa la nueva firma de correo electrónico!",
  viewInTheme: "Ver en tema",
  light: "claro",
  dark: "oscuro",
  customized: "Personalizados",
  default: "Predeterminado",
  noDataAvailable: "No hay datos disponibles",
  selectedEmails: "Correos electrónicos seleccionados",
  lastUpdate: "Última actualización",
  loading: "Cargando",
  noResults: "Sin resultados",
  linesPerPage: "Líneas por página",
  userAddedToShifts: "añadido a los turnos, ¡onboarding completado!",
  insertUserIntoCalendar: "Insertar usuario en calendarios de la empresa",
  userCalendars: "Calendarios del usuario",
  addUserCalendarsDescription:
    "Agrega al usuario en calendarios de la empresa u otros usuarios para que pueda ver los eventos en el calendario.",
  schedule: "Agenda",
  description: "Descripción",
  addCalendar: "Agregar calendario",
  removerCalendar: "Eliminar calendario",
  selectCalendars: "Selecciona los calendarios para agregar al usuario.",
  selectCalendarsRemove:
    "Seleccione los calendarios que desea eliminar del usuario.",
  addCalendarDescription:
    'Los permisos de los usuarios (si pueden solo ver, añadir o modificar eventos) se configuran en el sitio de <a href="https://calendar.google.com/">Google Calendar</a>.',
  addCalendarsHelpText:
    "Si algún calendario no está disponible, actualiza la lista aquí",
  searchCalendars: "Buscar calendarios",
  calendarsNotFound: "No se encontraron los calendarios de la empresa",
  requestFunctionalityScopes:
    "Por favor, acepta los permisos en tu Google Workspace para usar esta funcionalidad.",
  requestFunctionalityScopesToNonAdminUser:
    "Por favor, solicita a tu administrador que acepte los permisos para usar esta funcionalidad.",
  companyDrives: "Drives de la empresa",
  addUserToSharedDrivers: "Agregar usuario a drives compartidos",
  addUserToSharedDriversDescription:
    "Agrega al usuario en drives para que pueda acceder a información de la empresa o del área a la que pertenece.",
  addSharedDrive: "Agregar drive compartido",
  addSharedDriveDescription:
    "Selecciona el drive al que deseas agregar al usuario",
  companyDrive: "Drive de la empresa",
  defineTheRole: "Definir el cargo",
  clickToCopyData: "Haz clic aquí para volver y copiar los datos.",
  homePage: "Página de inicio",
  viewInFullscren: "Ver en pantalla completa",
  noDataFound: "No se encontraron datos",
  of: "de",
  viewingModel: "Visualizando modelo",
  viewingModelAs: "Visualizando modelo como",
  thisModelEmpty: "Este modelo está vacío",
  marketplaceInstall:
    "Conecta Suite no está instalado en tu Google Workspace, instálalo ahora para continuar.",
  goToMarketplace: "Ir al Marketplace",
  availableIndefinitely: "¡Disponible por tiempo limitado!",
  massMigration: "Migración masiva",
  conectaSign: "Aplicación masiva",
  conectaTrack: "Conecta Track",
  conectaTransfer: "Conecta Transfer",
  conectaSuite: "Conecta Suite",
  conectaPartners: "Conecta Partners",
  usersPermissions: "Permisos de usuarios",
  contactUs: "Contáctanos",
  knowThePlans: "Conocer los planes",
  knowPlans: "Conocer planes",
  scheduleMeeting: "Agendar una reunión",
  hello: "Hola",
  letsTalk: "¿Hablamos?",
  concluded: "Concluido",
  concludedWithFailures: "Concluido con errores",
  unfinished: "No concluido",
  resume: "Reanudar",
  failed: "Fallido",
  unknown: "?",
  origin: "Origen",
  destination: "Destino",
  author: "Autor",
  sharedDrive: "Drive compartido",
  theStart: "Inicio",
  theFinish: "Finalización",
  soon: "Próximamente",
  status: "Estado",
  date: "Fecha",
  unavailable: "No disponible",
  unavailableOnYourPlan: "No disponible en tu plan",
  doNotHavePermission: "No tienes permiso",
  feedbackRatingTitle: "Deja tu opinión sobre la funcionalidad",
  reversibleAction:
    "La siguiente acción puede deshacerse en cualquier momento.",
  irreversibleAction: "La siguiente acción no podrá deshacerse.",
  exitWithoutSaving:
    "Algunos cambios no fueron guardados. ¿Deseas salir sin guardar?",
  sureToContinue: "¿Estás seguro de que deseas confirmar esta acción?",
  sureToContinueAction: "¿Estás seguro de que deseas <b>{action}</b>?",
  planDetails: "Detalles del plan",
  serviceDetails: "Detalles del servicio",
  service: "Servicio",
  plan: "Plan",
  new: "Nuevo",
  newPlan: "Nuevo plan",
  upsellTitle: "Actualización disponible para tu empresa",
  checkPlans: "Conoce los planes",
  assigned: "Asignada",
  removed: "Eliminada",
  tasks: "Tareas",
  running: "En curso",
  canceled: "Cancelada",
  interrupted: "Interrumpida",
  finished: "Finalizada",
  close: "Cerrar",
  closed: "Cerrada",
  pause: "Pausar",
  userSelection: "Selección de usuario",
  inventory: "Inventario",
  transferEmails: "Transferir correos",
  transferDrive: "Transferir Drive",
  transferCalendar: "Transferir calendario",
  licences: "Licencias",
  shortly: "Próximamente",
  password: "Contraseña",
  recipientEmail: "Correo del destinatario",
  choiceDateToSendEmail: "Elegir fecha para enviar el correo",
  limitDate: "Límite de 30 días a partir de hoy",
  dateToschedule: "Fecha de programación",
  sendCopyToMe: "Enviar copia para mí",
  sendEmail: "Enviar correo",
  scheduleSend: "Programar envío",
  notValidEmail: "El correo no es válido",
  roles: {
    organizer: "Organizador",
    fileOrganizer: "Organizador de archivos",
    writer: "Editor",
    commenter: "Comentarista",
    reader: "Lector",
  },
  howToUseInformation: "Cómo usar Información en tu firma de correo.",
  email: "Correo electrónico",
  saveOnlyDescription:
    "Guardar los cambios realizados en la Información sin volver a aplicar la plantilla de firma a los usuarios que la utilizan",
  saveAndReapplyDescription:
    "Guardar los cambios y volver a aplicar la plantilla de firma con la Información actualizada",
  userHasNoModelApplied:
    "Este usuario no tiene un modelo aplicado que pueda ser reaplicado.",
  editInGoogleDashboard: "Editar en Google",
  somethingWentWrong: "Algo salió mal",
  appConnected: "Aplicación conectada",
  appDisconnected: "Aplicación desconectada",
  disconnectApp: "Desconectar aplicación",
  getLastAuth: "Obtener fecha de última autorización",
  lastAuthDate: "Fecha de última autorización",
  userAppsDisconnected:
    "El usuario {userName} fue desconectado de las siguientes aplicaciones: {apps}",
  all: "Todos",
  usersSelecteds: "Usuarios seleccionados",
  details: "Detalles",
  customizedModel: "Modelo personalizado",
  defaultModel: "Modelo predeterminado",
  actionCanBeUndone: "Esta acción puede deshacerse en cualquier momento.",
  selected: "seleccionado",
  users: "usuarios",
  member: "Miembro",
  admin: "Administrador",
  anyType: "Cualquier tipo",
  request: "Solicitar",
  insert: "Insertar",
  remove: "Eliminar",
  selectLatest1User:
    "Selecciona al menos 1 usuario para habilitar las opciones",
  selecteds: "seleccionados",
  googleAdmin: "Administrador",
  lastSignatureApplied: "Última firma aplicada en Conecta Suite",
  gmailUsage: "Estado del correo",
  gmailUsageDescription: "Tiene la bandeja de correo activa o inactiva",
  associatedName: "Nombre asociado",
  emailServiceIsDisabled:
    "La licencia de correo electrónico está desactivada para este usuario",
  userRestrictDescription:
    "La firma de correo de este usuario solo se modificará mediante confirmación por correo del mismo.",
  usersRestrictedsDescription:
    "Se seleccionaron uno o más usuarios restringidos. La firma solo se aplicará con su confirmación por correo.",
  descriptionMakeUserRestricted:
    "Después de aplicar una firma de correo, los usuarios restringidos solo tendrán su firma modificada con aprobación vía correo.",
  makeThisUserRestrict: "¿Deseas hacer que este usuario sea restringido?",
  removeRestrictionFromThisUser:
    "¿Deseas quitar la restricción de este usuario?",
  descriptionRemoveRestrictionFromThisUser:
    "Los usuarios restringidos solo tendrán su firma modificada con aprobación por correo tras el intento de aplicación.",
  alertRemoveRestrictionFromThisUser:
    "Desactivar la restricción permitirá que la firma del usuario sea modificada en cualquier momento por cualquier colaborador con acceso a Conecta Sign",
  makeUserRestricted: "Hacer usuario restringido",
  removeUserRestriction: "Quitar restricción del usuario",
  type: "Tipo",
  primary: "Principal",
  secondary: "Secundario",
  userPrimaryEmail: "Correo principal del usuario",
  userRestrictionChange: "Cambiar restricción del usuario",
  requestUserUpdateInfo:
    "Solicitar al usuario la actualización de su información",
  viewAppliedSignature: "Ver firma aplicada",
  viewAppliedVacationMessage: "Ver mensaje de vacaciones aplicado",
  emailSignatureModelPreview: "Vista previa del modelo de firma",
  vacationModelPreview: "Vista previa del modelo de mensaje de vacaciones",
  emptyTagInfo:
    "Si <b>no hay alguna información</b>, la etiqueta correspondiente quedará <b>en blanco</b>",
  bulkActionNotAvailable:
    "Las acciones en masa y firmas de correo no están disponibles para tu plan actual, contrata ahora para usarlas.",
  availableOnleStandardPlan: "Disponible solo para planes Standard",
  youDoNotHavePermissionEmail:
    "No tienes permiso para administrar firmas de correo.",
  requestAccessToAdmin: "¡Solicita al administrador que habilite tu acceso!",
  customizeColumns: "Personalizar columnas",
  customizeColumnsDescription:
    "Controla la visualización de hasta 8 columnas simultáneas",
  moveColumnUp: "Mover columna hacia arriba",
  moveColumnDown: "Mover columna hacia abajo",
  toThe: "a los",
  notInformed: "No informado",
  alertAboutChangePayment:
    "Verifica si el cliente ha completado los datos de la tarjeta en Superlógica antes de cambiar el método. Dudas, contacta a financeiro@conectasuite.com",
  aboutChangePayment: "¡Este cambio no genera alteración en Superlógica!",
  past7Days: "Últimos 7 días",
  past3Months: "Últimos 3 meses",
  past6Months: "Últimos 6 meses",
  external: "Externo",
  backToGmail: "Volver a Gmail",
  userHasNoGroups:
    "Este usuario no pertenece a ningún grupo de Google Workspace.",
  hasDriveScopePending:
    "Esta funcionalidad no está activa debido a permisos pendientes en la aplicación Conecta Suite.",
  noUserPleaseSelect:
    "Ningún usuario seleccionado, por favor selecciona al menos uno.",
  selectStartEndDate: "Seleccionar fechas de inicio y fin",
  startEndDate: "Fechas de inicio y fin",
  enterInContact: "Contactar",
  vacationMessages: "Mensaje de vacaciones",
  activated: "ACTIVADO",
  deactivated: "DESACTIVADO",
  active: "Activo",
  disabled: "Deshabilitado",
  inactive: "Inactivo",
  seeInfo: "Ver información",
  models: "Modelos",
  seePlan: "Ver plan",
  exit: "Salir",
  seeUser: "Ver usuario",
  shortcut: "Atajo{plural}",
  intro: "Introducción",
  shift: "Turno",
  upgradeCTA: "Realizar mejora",
  attention: "Atención",
  or: "O",
  see: "Ver",
  actions: "Acciones",
  used: "Usados",
};
